// src/theme.ts
import { createTheme, Theme } from '@mui/material/styles';
import { appTheme } from './styles/theme';

export const createAppTheme = (direction: 'rtl' | 'ltr'): Theme => {
  const isRTL = direction === 'rtl';
  const primaryFont = isRTL
    ? "'Cairo', 'Roboto', 'Helvetica', 'Arial', sans-serif"
    : "'Roboto', 'Helvetica', 'Arial', 'Cairo', sans-serif";
  const headingFont = isRTL
    ? "'Cairo', sans-serif"
    : "'Roboto', 'Helvetica', 'Arial', sans-serif";

  return createTheme({
    direction,
    palette: {
      mode: 'light',
      primary: {
        main: '#246BFD',
        light: '#a478e8',
        dark: appTheme.colors.primary.dark,
      },
      secondary: {
        main: 'rgb(251, 191, 36)',
      },
      background: {
        default: appTheme.colors.background.paper,
        paper: appTheme.colors.background.paper,
      },
      text: {
        primary: appTheme.colors.text.primary,
        secondary: appTheme.colors.text.secondary,
      },
    },
    typography: {
      fontFamily: primaryFont,
      h1: { fontFamily: headingFont, fontWeight: 700 },
      h2: { fontFamily: headingFont, fontWeight: 700 },
      h3: { fontFamily: headingFont, fontWeight: 600 },
      h4: { fontFamily: headingFont, fontWeight: 600 },
      h5: { fontFamily: headingFont, fontWeight: 600 },
      h6: { fontFamily: headingFont, fontWeight: 600 },
      body1: { fontFamily: headingFont, fontWeight: 400 },
      body2: { fontFamily: headingFont, fontWeight: 400 },
      button: { fontFamily: headingFont, fontWeight: 600, textTransform: 'none' },
      caption: { fontFamily: headingFont },
      overline: { fontFamily: headingFont },
      subtitle1: { fontFamily: headingFont },
      subtitle2: { fontFamily: headingFont },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: { fontFamily: headingFont },
          '*': { fontFamily: headingFont },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: { fontFamily: headingFont, fontWeight: 600 },
          startIcon: {
            ...(isRTL && {
              marginRight: -4,
              marginLeft: 8,
            }),
          },
          endIcon: {
            ...(isRTL && {
              marginLeft: -4,
              marginRight: 8,
            }),
          },
        },
      },
      MuiTypography: {
        defaultProps: {
          variantMapping: {
            h1: 'h1', h2: 'h2', h3: 'h3', h4: 'h4', h5: 'h5', h6: 'h6',
            subtitle1: 'h6', subtitle2: 'h6', body1: 'p', body2: 'p',
          },
        },
        styleOverrides: {
          root: { fontFamily: headingFont },
        },
      },
      MuiIconButton: {
        styleOverrides: { root: { fontFamily: headingFont } },
      },
      MuiMenuItem: {
        styleOverrides: { root: { fontFamily: headingFont } },
      },
    },
  });
};

// Default theme for backward compatibility
const theme = createAppTheme('rtl');
export default theme;
